<ng-container *transloco="let t">
  <form hidden id="inputForm" [formGroup]="inputForm" *ngIf="step$ | async as step" (ngSubmit)="submit(step)"></form>
  <div class="row justify-content-center text-center mt-3">
    <div class="col-12 col-sm-6 col-md-4">
      <div class="row justify-content-between w-100 no-gutters">
        <div class="col m-0 p-0 text-size-5"><span>{{ hours$ | async}}</span></div>
        <div class="col m-0 p-0 text-size-5"><span>:</span></div>
        <div class="col m-0 p-0 text-size-5"><span>{{ minutes$ | async}}</span></div>
        <div class="col m-0 p-0 text-size-5"><span>:</span></div>
        <div class="col m-0 p-0 text-size-5"><span>{{ seconds$ | async}}</span></div>
      </div>
    </div>
  </div>
  <div class="row w-100 no-gutters justify-content-center text-center my-3">
    <div class="col-3">
      <button *ngIf="!(isRunning$ | async)" type="button" class="p-3" mat-raised-button color="accent"
        (click)="start(step)">
        <mat-icon title="{{t('buttons.start')}}" class="icon-size-3">play_arrow</mat-icon>
      </button>
      <button *ngIf="(isRunning$ | async)" type="button" mat-raised-button class="p-3" color="accent"
        (click)="stop(step)">
        <mat-icon title="{{t('buttons.stop')}}" class="icon-size-3">pause</mat-icon>
      </button>
    </div>
  </div>
</ng-container>
